module.exports = __webpack_public_path__ + "img/20221115楼书1.fa54be1c.png";